export const defaultPlanInfo = {
  id: "business",
  name: "Business",
  title: "Free 30-Day Trial",
  featureList: [
    "All Essentials Features",
    "CRM Integration",
    "Roles Assignment & Task Routing",
    "Reporting for Insights",
    "Conditional Logic",
    "1:1 Consulting with Hubly Ops Gurus (4 sessions annually)",
    "Annual Business Review Meeting",
  ],
  planOptions: [
    {
      planId: "business-annual-user",
      name: "Yearly",
      trial: {
        period: {
          length: 30,
          of: "days",
        },
      },
      pricing: {
        currency: "USD",
        monthlyPrice: "8900",
        firstBillPrice: "106800",
        billedToday: "0",
        billingPeriod: "yearly",
      },
    },
    {
      planId: "business-monthly-user",
      name: "Monthly",
      trial: {
        period: {
          length: 30,
          of: "days",
        },
      },
      pricing: {
        currency: "USD",
        monthlyPrice: "11000",
        firstBillPrice: "11000",
        billedToday: "0",
        billingPeriod: "monthly",
      },
    },
  ],
};

export function createPlanInfo(planInfo) {
  return { ...defaultPlanInfo, ...planInfo };
}
